import React from 'react';
import { ReportProblem } from '@mui/icons-material';
import { useHistory } from 'react-router';
import AccountMenuItem from './AccountMenuItem';
import { Colors } from 'library';

export default function SubmitReportMenuItem() {
    const history = useHistory();

    const submitReportClicked = () => {
        history.push('/reports/submit');
    };

    return (
        <AccountMenuItem
            icon={<ReportProblem style={{ color: Colors.darkNavy }} />}
            text="Submit a Report"
            action={submitReportClicked}
        />
    );
}
